import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.is-array";
import _omit from "lodash/omit";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Lazy from 'react-lazyload';
import Image from '@nerdwallet/react-image';
import styles from './marketplace-product-card.module.less';

var ProductCardImageWrapper = function ProductCardImageWrapper(_ref) {
  var backgroundColor = _ref.backgroundColor,
      className = _ref.className,
      imageData = _ref.imageData,
      imageClassName = _ref.imageClassName,
      lazyLoadEnabled = _ref.lazyLoadEnabled,
      objectFit = _ref.objectFit,
      isKetoCard = _ref.isKetoCard;
  var alt = imageData.alt,
      breakpoint = imageData.breakpoint,
      imageDimensions = imageData.imageDimensions,
      imageDimensionsMobile = imageData.imageDimensionsMobile,
      src = imageData.src,
      srcSet = imageData.srcSet,
      sizes = imageData.sizes;
  /**
   * @type {[Array, Function]} Window dimensions
   */

  var _useState = useState([0, 0]),
      _useState2 = _slicedToArray(_useState, 2),
      size = _useState2[0],
      setSize = _useState2[1];

  useLayoutEffect(function () {
    var updateSize = function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener('resize', updateSize);
    updateSize();
    return function () {
      return window.removeEventListener('resize', updateSize);
    };
  }, []);

  var _size = _slicedToArray(size, 1),
      width = _size[0];

  var naturalHeight = imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.height;
  var naturalWidth = imageDimensions === null || imageDimensions === void 0 ? void 0 : imageDimensions.width; // adjust lazy load placeholder height according to screen width

  if (width <= breakpoint && width !== 0) {
    naturalHeight = imageDimensionsMobile === null || imageDimensionsMobile === void 0 ? void 0 : imageDimensionsMobile.height;
    naturalWidth = imageDimensionsMobile === null || imageDimensionsMobile === void 0 ? void 0 : imageDimensionsMobile.width;
  }

  var imageProps = _omit(imageData, ['breakpoint', 'imageDimensions', 'imageDimensionsMobile']);

  var lazyImage = /*#__PURE__*/React.createElement(Lazy, {
    offset: 100
  }, /*#__PURE__*/React.createElement("img", {
    alt: alt,
    className: imageClassName,
    src: src,
    srcSet: srcSet,
    sizes: sizes
  }));
  return lazyLoadEnabled && naturalHeight && naturalWidth ? isKetoCard ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.lazyImageWrapper])
  }, lazyImage) : /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.lazyImageWrapper, className]),
    style: {
      height: naturalHeight,
      width: naturalWidth
    }
  }, lazyImage) : /*#__PURE__*/React.createElement(Image, _extends({
    backgroundColor: backgroundColor,
    className: className,
    imageClassName: imageClassName,
    objectFit: objectFit
  }, imageProps));
};

ProductCardImageWrapper.propTypes = {
  /**
   * Prop passed into react-image.
   */
  backgroundColor: PropTypes.string,

  /**
   * Styling for the image container.
   */
  className: PropTypes.string,

  /**
   * Styling for the image.
   */
  imageClassName: PropTypes.string,
  imageData: PropTypes.shape({
    alt: PropTypes.string,

    /**
     * The window size when we switch from
     * the desktop image to the mobile one
     */
    breakpoint: PropTypes.number,

    /**
     * Dimensions of desktop card image.
     */
    imageDimensions: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number
    }),

    /**
     * Dimensions of the mobile card image.
     */
    imageDimensionsMobile: PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number
    }),
    src: PropTypes.string,
    srcSet: PropTypes.string,
    sizes: PropTypes.string
  }),

  /**
   * To enable or disable lazyloading of images.
   */
  lazyLoadEnabled: PropTypes.bool,

  /**
   * Prop passed into react-image.
   */
  objectFit: PropTypes.string,
  isKetoCard: PropTypes.bool
};
export default ProductCardImageWrapper;